import { render, staticRenderFns } from "./Top10HorizontalTitleListGraphql.vue?vue&type=template&id=5ba39d2f&scoped=true"
import script from "./Top10HorizontalTitleListGraphql.vue?vue&type=script&setup=true&lang=ts"
export * from "./Top10HorizontalTitleListGraphql.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Top10HorizontalTitleListGraphql.vue?vue&type=style&index=0&id=5ba39d2f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba39d2f",
  null
  
)

export default component.exports